import React from 'react';
import { motion } from 'framer-motion';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onChange,
  className = ''
}: TabsProps) {
  return <div className={`flex space-x-1 bg-gray-100 p-1 rounded-lg ${className}`} data-id="element-211">
      {tabs.map(tab => {
      const isActive = activeTab === tab.id;
      return <button key={tab.id} onClick={() => onChange(tab.id)} className={`relative flex-1 px-3 py-1.5 text-sm font-medium rounded-md transition-colors z-10 ${isActive ? 'text-[var(--primary)]' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-212">
            {isActive && <motion.div layoutId="activeTab" className="absolute inset-0 bg-white rounded-md shadow-sm" transition={{
          type: 'spring',
          bounce: 0.2,
          duration: 0.6
        }} style={{
          zIndex: -1
        }} data-id="element-213" />}
            {tab.label}
          </button>;
    })}
    </div>;
}